import {
  DownPayment,
  MonthlyPayment,
  Price,
  ShippingInfo,
  TrimMileage,
  VehicleImage,
  VehicleInfoContainer,
  YearMakeModel
} from './SkeletonTile.styles';
import TileContainer from '../TileContainer';

const SkeletonTile = () => (
  <TileContainer>
    <VehicleImage />

    <VehicleInfoContainer>
      <section className="flex flex-col gap-4">
        <YearMakeModel />
        <TrimMileage />
      </section>

      <section className="flex items-end justify-between">
        <Price />

        <p className="flex flex-col items-end">
          <MonthlyPayment />
          <DownPayment />
        </p>
      </section>

      <ShippingInfo />
    </VehicleInfoContainer>
  </TileContainer>
);

export default SkeletonTile;
